import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { InvoiceExportIssue } from "../../../utils/invoiceExport.utils";

const OPEN_CLASSES: Record<InvoiceExportIssue["kind"], string> = {
	FAILED: "border-red-200 bg-red-50 text-red-700",
	HELD: "border-amber-300 bg-amber-50 text-amber-800",
	ATTACHMENT_MISSING: "border-sky-200 bg-sky-50 text-sky-800",
};

/** Label key of a resolved item: what the admin decided, not what went wrong. */
function resolvedLabelKey(issue: InvoiceExportIssue) {
	if (issue.kind === "ATTACHMENT_MISSING") return "invoiceBatch.exportStatus.ATTACHMENT_RESOLVED";
	if (issue.resolved?.outcome === "CONFIRMED_EXPORTED")
		return "invoiceBatch.exportStatus.CONFIRMED_EXPORTED";
	return "invoiceBatch.exportStatus.RELEASED";
}

interface Props {
	issue: InvoiceExportIssue;
	className?: string;
}

/**
 * Status chip of one per-invoice export follow-up item. Open items are
 * coloured by severity, resolved ones turn quiet gray.
 */
const InvoiceExportStatusChip: React.FC<Props> = ({ issue, className }) => {
	const { t } = useTranslation();

	const label = issue.resolved
		? t(resolvedLabelKey(issue) as any)
		: t(`invoiceBatch.exportStatus.${issue.kind}` as any);

	return (
		<span
			className={cn(
				"inline-flex w-fit items-center whitespace-nowrap rounded-full border border-solid px-2 py-0.5 text-xs font-medium",
				issue.resolved ? "border-gray-200 bg-gray-50 text-gray-600" : OPEN_CLASSES[issue.kind],
				className
			)}
		>
			{label}
		</span>
	);
};

export default InvoiceExportStatusChip;
